import { render, staticRenderFns } from "./NormalSimpleSolidButton.vue?vue&type=template&id=0e89d1ae&scoped=true&"
import script from "./NormalSimpleSolidButton.vue?vue&type=script&lang=js&"
export * from "./NormalSimpleSolidButton.vue?vue&type=script&lang=js&"
import style0 from "./NormalSimpleSolidButton.vue?vue&type=style&index=0&id=0e89d1ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e89d1ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
